module.exports = kolibriGlobal.coreVue.components.CoreFullscreen;